import React from 'react';
import PropTypes from 'prop-types';

import {styled} from "@mui/material/styles";

import ListingIconButton from "components/Product/Table/ListingIconButton";

import {ReactComponent as Export} from "assets/img/import-linear.svg";
import {greyishBlue600} from "assets/jss/main";

ListingExportButton.propTypes = {
    tooltip: PropTypes.node,
    successMessage: PropTypes.node,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
};

const Wrapper = styled('span')({
    display: 'inline-flex',
    alignItems: 'center',
    gap: '12px'
});

const SuccessMessage = styled('span')({
    color: greyishBlue600,
    fontSize: '14px'
});

function ListingExportButton({successMessage, ...props}) {
    const button = <ListingIconButton icon={Export} {...props}/>;

    if (successMessage) {
        return (
            <Wrapper>
                {button}
                <SuccessMessage>{successMessage}</SuccessMessage>
            </Wrapper>
        );
    }

    return button;
}

export default ListingExportButton;
